var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sd-manual"},[_c('router-view',{on:{"product-model":_vm.emitProductModel,"current-tutorial":_vm.emitCurrentTutorial}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }